import { Component, OnDestroy, OnInit } from '@angular/core';
import { PageMetaService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { TicketWrapper } from "./model/ticket.model";
import { CustomTicketsService } from './services/custom-tickets.service';

@Component({
  selector: 'app-custom-tickets',
  templateUrl: './custom-tickets.component.html',
  styleUrls: ['./custom-tickets.component.scss'],
  standalone: false
})
export class CustomTicketsComponent implements OnInit, OnDestroy {
  protected subscriptions: Subscription = new Subscription();
  pageTitle: string;
  pageDescription: string;
  isLoaded$: Observable<boolean>;
  private DEFAULT_PAGE_SIZE = 10;
  private sortMapping = {
    byCreationDateTime: 'CreationDateTime',
  };
  sortLabels: Observable<{ byCreationDateTime: string }>;
  tickets$: Observable<TicketWrapper>;

  sort = 'byCreationDateTime';
  sortOptions = [
    {
      code: 'byCreationDateTime',
      selected: false,
    },
  ];

  constructor(
    protected pageMetaService: PageMetaService,
    protected ticketsService: CustomTicketsService,
  ) { }

  pageChange(page: number): void {
    const event: { sortCode: string; currentPage: number } = {
      sortCode: this.sortMapping[this.sort],
      currentPage: page,
    };
    this.fetchTickets(event);
  }

  private fetchTickets(event: { sortCode: string; currentPage: number }): void {
    this.ticketsService.getTickets(
      this.DEFAULT_PAGE_SIZE,
      event.currentPage,
      event.sortCode,
    );
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageMetaService.getMeta().subscribe(
        data => {
          this.pageTitle = data.title;
          this.pageDescription = data.description;
        },
      ),
    );
    this.isLoaded$ = this.ticketsService.getTicketsLoading();
    this.tickets$ = this.ticketsService.getAndLoadTickets();
    this.ticketsService.getTickets(this.DEFAULT_PAGE_SIZE);
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
